export function setupIsScrolledDetector() {

  let isScrolled = false;
  let specialPage = false;
  const scrollThreshold = window.innerHeight / 100 * 1;
  let specialPageId = document.getElementById('special-page');


  if (specialPageId) {
    document.body.classList.add("-is-scrolled");

    specialPage = true;
  } else {
    specialPage = false;
    document.body.classList.remove("-is-scrolled");

  }

  const handleScroll = () => {
    if (!isScrolled && window.scrollY > scrollThreshold && !specialPage) {
      document.body.classList.add("-is-scrolled");
      isScrolled = true;
    } else if (isScrolled && window.scrollY <= scrollThreshold && !specialPage) {
      document.body.classList.remove("-is-scrolled");
      isScrolled = false;
    }
  };

  window.addEventListener('scroll', handleScroll)
}